export enum Mode {
  READ,
  WRITE,
  LOADING,
  ADD,
  EDIT,
}
